import { render, staticRenderFns } from "./SearchNews.vue?vue&type=template&id=3c97740b&scoped=true"
import script from "./SearchNews.vue?vue&type=script&lang=ts"
export * from "./SearchNews.vue?vue&type=script&lang=ts"
import style0 from "./SearchNews.vue?vue&type=style&index=0&id=3c97740b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c97740b",
  null
  
)

export default component.exports